import { render } from "./MergeAnnotationDialog.vue?vue&type=template&id=531d6808&scoped=true"
import script from "./MergeAnnotationDialog.vue?vue&type=script&lang=js"
export * from "./MergeAnnotationDialog.vue?vue&type=script&lang=js"

import "./MergeAnnotationDialog.vue?vue&type=style&index=0&id=531d6808&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531d6808"]])

export default __exports__